import { Image } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import ActionButton from 'components/action-button';
import Link from 'components/link';
import { Typography } from 'components/ui';
import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';
import { routes } from 'utils/routing';

import { Perks } from './perks';

const openLinkIcon = require('./open-link-icon.svg');

export const UnauthenticatedProfile = () => {
  const { openSignInModal } = useAuthContext();
  const isDesktopLarge = useIsDesktopLargeBreakpoint();

  const ctaLabel = t('signInUp');
  const isCanada = region === Region.CA;

  return (
    <View style={styles.mainContainer}>
      <Typography
        variant="headerOne"
        fontSize={isDesktopLarge ? 30 : undefined}
        style={styles.header}
      >
        {t('loyaltyProfileMeetTheProgram')}
      </Typography>
      <Perks />
      <View style={styles.footer}>
        <Typography variant="copyOne" textAlign="center">
          {t('loyaltyProfileJoinTheProgram')}
        </Typography>
        <ActionButton
          fullWidth
          accessibilityLabel={ctaLabel}
          accessibilityRole="button"
          onPress={() => openSignInModal()}
        >
          {ctaLabel}
        </ActionButton>
        <Link to={isCanada ? routes.bkRewards : routes.royalPerks} style={styles.learnMoreLink}>
          <Typography style={styles.learnMoreLinkText} fontFamily="heading">
            {t('loyaltyProfileLearnMore', 'More About Royal Perks')}
          </Typography>
          <Image source={openLinkIcon} style={styles.openLinkIcon} />
        </Link>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    alignItems: 'stretch',
    paddingVertical: spacing.$6,
    paddingHorizontal: spacing.$4,
    gap: spacing.$4,
  },
  header: {
    marginBottom: spacing.$2,
    textAlign: 'center',
    lineHeight: primitive.fontSizes['3xl'],
  },
  footer: {
    alignItems: 'center',
    gap: spacing.$3,
  },
  learnMoreLink: {
    alignItems: 'flex-end',
    gap: spacing.$1,
    margin: spacing.$2,
  },
  learnMoreLinkText: {
    fontSize: primitive.fontSizes.xs,
    alignItems: 'center',
    display: 'flex',
    lineHeight: primitive.fontSizes.sm,
  },
  openLinkIcon: {
    width: 10,
    height: 10,
    marginBottom: 1,
  },
});
